import { createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  basepath: import.meta.env.BASE_URL,
})

// Register router for type safety across the app
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
